import { createSlice } from '@reduxjs/toolkit';
import axiosLib from 'axios';
import axios from 'src/utils/axios';

const initialState = {
  contests: [],
  selectedContest: null,
  isFetching: false
};

const slice = createSlice({
  name: 'contest',
  initialState,
  reducers: {
    getContests(state, action) {
      const { contests } = action.payload;

      contests.sort((a, b) => {
        if (a.id < b.id) {
          return 1;
        }

        if (a.id > b.id) {
          return -1;
        }

        return 0;
      });

      state.contests = contests;
    },
    setContests(state, action) {
      const { contests } = action.payload;

      state.contests = contests;
    },
    setSelectedContest(state, action) {
      const { contest } = action.payload;

      state.selectedContest = contest;
    },
    setFetching(state, action) {
      const { isFetching } = action.payload;

      state.isFetching = isFetching;
    }
  }
});

export const { reducer } = slice;

export const getContests = () => async dispatch => {
  const query = `
    {
      admin{
        contests{
          id,
          accessLevel,
          collectionId,
          name,
          nameId,
          active,
          secret,
          dateFrom,
          dateTo,
          latitude,
          longitude,
          contestOrganizer{
            id,
            userId,
            name
          }
        }
      }
    }
  `;

  dispatch(slice.actions.setFetching({ isFetching: true }));

  const response = await axios.post('/g', { query });

  dispatch(slice.actions.setFetching({ isFetching: false }));

  dispatch(slice.actions.getContests(response.data.data.admin));
};

let fetchCtl = null;

export const getContest = async contestId => {
  const query = `
    {
      contest{
        id,
        accessLevel,
        collectionId,
        mainColor,
        allowLocationQrCodes,
        sponsorWebsiteUrl,
        sponsorLogoUrl,
        sponsorLogoBackgroundColor,
        map {
          url,
        }
        name,
        nameId,
        secret,
        active,
        sortOrder,
        dateFrom,
        dateTo,
        latitude,
        longitude,
        contestOrganizer{
          id,
          userId,
          name
        }
      }
    }
  `;

  if (fetchCtl) {
    fetchCtl.cancel();
  }
  fetchCtl = axiosLib.CancelToken.source();

  try {
    const response = await axios.post(`/admin/${contestId}/g`, { query }, {
      cancelToken: fetchCtl.token
    });

    fetchCtl = null;
    return response.data.data.contest;
  } catch (error) {
    if (error?.message !== 'canceled') {
      fetchCtl = null;
      console.error(error);
    }
    return undefined;
  }
};

export const setSelectedContest = contest => async dispatch => {
  dispatch(slice.actions.setSelectedContest({ contest }));
};

export const clearContests = () => async dispatch => {
  dispatch(slice.actions.setContests({ contests: [] }));
};
